import React, { FC } from "react";
import getConfig from "next/config";
import { withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import { GetServerSideProps, GetServerSidePropsContext } from "next";
import { ShowsDashboardDict, Dashboards } from "../src/models/ShowDashboard";
import { readShowsDashboard } from "../src/services/ShowService";
import Head from "next/head";
import Footer from "../src/components/Footer/Footer";
import ResponsiveAppBar from "../src/components/ResponsiveAppBar/ResponsiveAppBar";
import Show from "../src/pages/Show/Show";
import withAuthHandler from "../src/components/Auth/WithAuthHandler/WithAuthHandler";
import withAdminAuthHandler from "../src/components/Auth/WithAdminAuthHandler/WithAdminAuthHandler";
import { useColorModeContext } from "../src/contexts/CustomThemeProvider";
import { useAuthContext } from "src/contexts/AuthContext";

interface HomePageProps extends WithRouterProps {
  dashboards: ShowsDashboardDict;
  companyHealthScore: number;
}

const HomePage: FC<HomePageProps> = ({
  dashboards,
  companyHealthScore,
}) => {
  const seoTitle = "Home | That's The Ticket";
  const { user } = useAuthContext();
  const { setColorMode } = useColorModeContext();
  setColorMode("light")

  return (
    <>
      <Head>
        <title>{`${seoTitle}`}</title>
        <meta key="ogTitle" property="og:title" content={seoTitle} />
        <meta key="twitterTitle" name="twitter:title" content={seoTitle} />
      </Head>

      <ResponsiveAppBar user={user} />

      <Show dashboards={dashboards} companyHealthScore={companyHealthScore} />

      <Footer />
    </>
  );
};

export default withAuthHandler(withAdminAuthHandler(withRouter(HomePage)));

export const getServerSideProps: GetServerSideProps = async ({
  params,
  req,
  res,
}: GetServerSidePropsContext) => {
  const { serverRuntimeConfig } = getConfig();

  const BACKEND_URL =
    process.env.BACKEND_URL || serverRuntimeConfig?.backendUrl;

  const response = await readShowsDashboard(BACKEND_URL);

  const data = response.data as Dashboards;

  res.setHeader(
    "Cache-Control",
    "public, s-maxage=2700, stale-while-revalidate=3600"
  );
  return {
    props: {
      dashboards: data?.dashboards ? data.dashboards : null,
      companyHealthScore: data?.companyHealthScore
        ? data.companyHealthScore
        : null,
    },
  };
};
